import Accordion from 'entities/Accordion'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { DateRangePicker } from '@mui/x-date-pickers-pro/DateRangePicker'
import { useConfigStore } from 'shared/store/configSlice'
import { Moment } from 'moment'
import { useEffect, useState } from 'react'
import { DateRange } from '@mui/x-date-pickers-pro/models'
import { MOMENT_FORMAT } from 'shared/globalConsts'
import { DataGrid } from '@mui/x-data-grid'
import { RenderIf } from 'shared/helpers/renderIf'
import DeleteIcon from '@mui/icons-material/DeleteOutline'
import { DeleteCellComponent } from './styled'

export const DaysOff = () => {
  const daysOff = useConfigStore().config?.tableReservationConfig?.daysOff
  const updateTableReservationConfig = useConfigStore().updateTableReservationConfig

  const [disabledDates, setDisabledDates] = useState<string[]>([])
  useEffect(() => {
    if (daysOff) {
      setDisabledDates(daysOff?.split(','))
    }
  }, [daysOff])

  const addOneDay = (value: Moment | null) => value && updateDaysOff(value.format(MOMENT_FORMAT))
  const addDaysRange = (value: DateRange<Moment>) => {
    if (value[0] && value[1]) {
      updateDaysOff(`${value[0].format(MOMENT_FORMAT)}-${value[1].format(MOMENT_FORMAT)}`)
    }
  }
  const updateDaysOff = (valueToSet: string) => {
    updateTableReservationConfig({ daysOff: `${daysOff},${valueToSet}` })
  }

  const checkIfDateISDisabled = (date: Moment) =>
    disabledDates.some(dDate => {
      if (dDate?.includes('-')) {
        return date.isBetween(dDate.split('-')[0], dDate.split('-')[1], undefined, '[]')
      } else {
        return date.isSame(dDate)
      }
    })

  const deleteCell = (el: any) => {
    const onDeleteClick = () => {
      updateTableReservationConfig({
        daysOff: disabledDates?.filter(dd => dd !== el?.row?.value)?.join(',')
      })
    }
    return (
      <DeleteCellComponent onClick={onDeleteClick}>
        <DeleteIcon />
      </DeleteCellComponent>
    )
  }

  return (
    <Accordion title='Days off'>
      <DatePicker
        key={`d_${daysOff}`}
        sx={{ width: '100%', marginBottom: '20px' }}
        label='Specific Date'
        format={MOMENT_FORMAT}
        onChange={addOneDay}
        disablePast
        shouldDisableDate={checkIfDateISDisabled}
      />
      <DateRangePicker
        key={`r_${daysOff}`}
        format={MOMENT_FORMAT}
        onChange={addDaysRange}
        shouldDisableDate={checkIfDateISDisabled}
      />
      <RenderIf condition={!!disabledDates?.length}>
        <DataGrid
          sx={{ marginTop: '20px' }}
          getRowId={(item: any) => `${item.value}`}
          columns={[
            {
              field: 'value',
              headerName: 'Dates',
              flex: 1
            },
            {
              field: 'reset',
              headerName: 'Delete date',
              width: 100,
              renderCell: deleteCell,
              align: 'center'
            }
          ]}
          rows={disabledDates?.map(dd => ({
            value: dd
          }))}
          disableRowSelectionOnClick
          hideFooter
        />
      </RenderIf>
    </Accordion>
  )
}
